import React from "react";
import { Link } from "react-router-dom";
import styles from "./NewsSection.module.css";

import newsData from "../news/NewsData.js";

// 🔥 tüm görselleri al
const images = require.context(
  "../news/assets",
  true,
  /\.(jpeg|jpg|JPG|png|webp)$/
);

// ✅ slug → ilk görseli bul
const getImage = (slug) => {
  const match = images
    .keys()
    .find((path) =>
      path.toLowerCase().includes(`/${slug.toLowerCase()}/`)
    );

  return match ? images(match) : null;
};

const news = [...newsData]
  .map((item) => ({
    ...item,
    image: getImage(item.slug),
    link: `/news/${item.slug}`,
  }))
  .sort((a, b) => new Date(b.date) - new Date(a.date));

export default function NewsSection() {
  return (
    <section className={styles.section}>
      {/* HEADER */}
      <div className={styles.header}>
        <h1>
          Neuigkeiten aus <br />
          unserem Schulleben
        </h1>

        <p>
          Bleiben Sie informiert über aktuelle Ereignisse, besondere Momente,
          spannende Projekte und das vielfältige Leben an unserer Schule.
        </p>
      </div>

      {/* GRID */}
      <div className={styles.grid}>
        {/* BIG CARD (FULL CLICKABLE) */}
        {news[0] && (
          <Link to={news[0].link} className={styles.bigCard}>
            {news[0].image && (
              <img src={news[0].image} alt={news[0].title} />
            )}

            <div className={styles.cardBody}>
              <span className={styles.smallDate}>
                ▣ {news[0].date}
              </span>

              <h3>{news[0].title}</h3>

              <span className={styles.arrow}>→</span>
            </div>
          </Link>
        )}

        {/* SMALL CARDS */}
        <div className={styles.smallGrid}>
          {news.slice(1, 5).map((item) => (
            <Link to={item.link} className={styles.card} key={item.slug}>
              {item.image && (
                <img src={item.image} alt={item.title} />
              )}

              <div className={styles.cardBody}>
                <span className={styles.smallDate}>
                  ▣ {item.date}
                </span>

                <h3>{item.title}</h3>

                <span className={styles.arrow}>→</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* BUTTONS */}
      <div className={styles.buttons}>
        <Link to="/news">Alle News ansehen →</Link>
      </div>
    </section>
  );
}